const AudioManager = require('AudioManager');
const AudioMap = require('AudioMap');
const AudioPlayOption = require('AudioPlayOption');

// ID generater for runtime
var NonUuidMark = '.';
/*
 * @param {string} [category] - You can specify a unique category to avoid id collision with other instance of IdGenerater
 */
function IdGenerater(category) {
    // init with a random id to emphasize that the returns id should not be stored in persistence data
    this.id = 0 | (Math.random() * 998);

    this.prefix = category ? (category + NonUuidMark) : '';
}

/*
 * @method getNewId
 * @return {string}
 */
IdGenerater.prototype.getNewId = function () {
    return this.prefix + (++this.id);
};

cc.Class({
    extends: cc.Component,

    onLoad() {
        if (!CC_DEBUG) {
            return;
        }

        const urlSearchParams = new URLSearchParams(window.location.search);
        const active = true; //TODO add launcher param cheatModePSConfig.get().cheatMode === PSConfig.CheatModes.Active;
        if ((active && urlSearchParams.get('audio') === 'true')) {
            cc.game.addPersistRootNode(this.node);
            this._loadScript();

            this.IdGenerater = new IdGenerater('audio-test');
            this._activeSoundControllers = {};
        }
    },

    // _init () {
    //     this.audioManager = cc.find('AudioManager').getComponent(AudioManager);
    //     this.mixer = new AudioVolumeMixer();
    //     this.mixer.init(this.audioManager);
    // },

    _loadScript() {
        const src = 'https://cdn.jsdelivr.net/npm/tweakpane@3.0.3/dist/tweakpane.min.js';

        const tweakpaneScript = document.createElement('script');
        tweakpaneScript.src = src;
        tweakpaneScript.onload = this.onScriptLoad.bind(this);

        document.head.appendChild(tweakpaneScript);
    },

    onScriptLoad() {
        this.init();

        this.visible = true;
        document.addEventListener('keyup', this.registerKeyBoardHandler.bind(this));
        // cc.systemEvent.on(cc.SystemEvent.EventType.KEY_UP, this.registerKeyBoardHandler, this);
    },

    registerKeyBoardHandler(e) {
        if(e.code === 'KeyH') {
            this.visible = !this.visible;

            if (this.visible) {
                this.htmlContainer.style.visibility = 'visible'
            } else {
                this.htmlContainer.style.visibility = 'hidden'
            }
        }
    },


    initHTMLContainer() {
        var elem = document.createElement('div');
        elem.classList.add('ps-audio-panel');
        document.body.appendChild(elem);

        this.htmlContainer = elem;

        const style = document.createElement('style');
        style.innerHTML = `
            .ps-audio-panel {
                position: absolute;
                width:400px;
                left:8px;
                top:8px
            }

            .tp-fldv_c {
                max-height: 80vh;
                overflow-y: scroll !important;
            }

            /* Works on Firefox */
            * {
            scrollbar-width: thin;
            scrollbar-color: blue orange;
            }

            /* Works on Chrome, Edge, and Safari */
            *::-webkit-scrollbar {
                width: 1px;
                height: 5px;
            }

            *::-webkit-scrollbar-track {
                background: var(--btn-fg);
            }

            *::-webkit-scrollbar-thumb {
                background-color: var(--cnt-fg);
                border: 0px;
            }

            /* Theme - can be created from here https://cocopon.github.io/tweakpane/theming.html#builder*/
            :root {
                --tp-base-background-color: hsla(230, 20%, 11%, 1);
                --tp-base-shadow-color: hsla(0, 0%, 0%, 0.2);
                --tp-button-background-color: hsla(230, 10%, 80%, 1);
                --tp-button-background-color-active: hsla(230, 10%, 95%, 1);
                --tp-button-background-color-focus: hsla(230, 10%, 90%, 1);
                --tp-button-background-color-hover: hsla(230, 10%, 85%, 1);
                --tp-button-foreground-color: hsla(230, 20%, 11%, 1);
                --tp-container-background-color: hsla(230, 25%, 16%, 1);
                --tp-container-background-color-active: hsla(230, 25%, 31%, 1);
                --tp-container-background-color-focus: hsla(230, 25%, 26%, 1);
                --tp-container-background-color-hover: hsla(230, 25%, 21%, 1);
                --tp-container-foreground-color: hsla(230, 10%, 80%, 1);
                --tp-groove-foreground-color: hsla(230, 20%, 8%, 1);
                --tp-input-background-color: hsla(230, 20%, 8%, 1);
                --tp-input-background-color-active: hsla(230, 28%, 23%, 1);
                --tp-input-background-color-focus: hsla(230, 28%, 18%, 1);
                --tp-input-background-color-hover: hsla(230, 20%, 13%, 1);
                --tp-input-foreground-color: hsla(230, 10%, 80%, 1);
                --tp-label-foreground-color: hsla(230, 12%, 48%, 1);
                --tp-monitor-background-color: hsla(230, 20%, 8%, 1);
                --tp-monitor-foreground-color: hsla(230, 12%, 48%, 1);
            }
        `
        document.head.appendChild(style);
    },

    initAudioPlayOption() {
        this.AudioPlayOptions = {};

        for (const prop in this.audioMap) {
            if (this.audioMap[prop] instanceof AudioPlayOption) {
                this.AudioPlayOptions[prop] = this.audioMap[prop];
            }
        }
    },

    init() {
        this.initHTMLContainer();

        this.pane = new Tweakpane.Pane({
            container: this.htmlContainer,
            title: 'Audio Tool',
            expanded: false,
        });


        this.audioManager = cc.find('AudioManager').getComponent(AudioManager);
        this.audioMap = cc.find('AudioMap').getComponent(AudioMap);

        this.initAudioPlayOption();
        this.buildAudioActiveSoundsPane();
        this.buildAudioPlayOptionPane();
        this.buildAudioVolumeMixerPane();
        this.buildDynamicCompressorPane();
        // console.log('audioMap', Object.keys(this.AudioPlayOptions))
    },

    buildAudioActiveSoundsPane() {
        this.analyserData = {
            enabled: false,
            minDecibels: Howler.analyser.minDecibels,
            maxDecibels: Howler.analyser.maxDecibels,
            smoothingTimeConstant: Howler.analyser.smoothingTimeConstant,
        }
        this.activeSoundMap = [];
        this.playHistory = {
            arr: [],
            json: ''
        };

        const c = this.pane.addFolder({
            title: 'Monitor',
            expanded: false,
        });

        // analyser
        const analyserFolder = c.addFolder({
            title: 'Analyser',
            expanded: false
        })

        analyserFolder.addInput(this.analyserData, 'enabled').on('change', () => {
            if (this.analyserData.enabled) {
                Howler.connectAnalyzer();
            } else {
                Howler.disconnectAnalyzer();
            }
        });

        // folder.addInput(compressorSettings, 'knee', { min: 0, max: 40 }).on('change', updateSideChainSettings.bind(this));


        // paly history
        const playHistoryFolder = c.addFolder({
            title: 'Play History',
            expanded: false
        })

        playHistoryFolder.addMonitor(this.playHistory, 'json', {
            label: 'history',
            multiline: true,
            lineCount: 10,
        });


        // active sounds
        this.activeSoundsFolder = c.addFolder({
            title: 'Active Audio',
            expanded: false
        })


        this.audioManager.node.on('play', this._handlePlaySound.bind(this));
        this.audioManager.node.on('end', this._handleEndSound.bind(this));
    },

    _handlePlaySound(soundMapEntry) {
        // console.log('play', soundMapEntry)

        const p = this._activeSoundControllers[soundMapEntry.id];

        const { spritename, clip } = soundMapEntry;

        this.playHistory.arr.push(`[${soundMapEntry.id}]${spritename ? 'S:'+ spritename : clip.name}`);
        if (this.playHistory.arr.length > 10) {
            this.playHistory.arr.shift();
        }
        this.playHistory.json = this.playHistory.arr.join('\n');

        if (!p) {
            const text = soundMapEntry.spritename ? soundMapEntry.spritename : soundMapEntry.clip.name;
            const c = this.activeSoundsFolder.addFolder({
                title: `[${soundMapEntry.id}]${text}`,
                expanded: false,
            });

            // if (soundMapEntry.spritename) {
            //     c.addMonitor(soundMapEntry, 'spritename');
            // }

            // if (soundMapEntry.clip) {
            //     c.addMonitor(soundMapEntry.clip, 'name');
            // }

            if (soundMapEntry.loop) {
                c.addButton({ title: 'Change Audio Clip' }).
                    on('click', this.handlePlayingAudioClipChange.bind(this, soundMapEntry));
            }

            this._activeSoundControllers[soundMapEntry.id] = c;
        }
    },

    handlePlayingAudioClipChange(soundMapEntry) {
        var input = document.createElement('input');
        input.setAttribute("type", "file");
        input.click();
        input.addEventListener('change', this.handlePlayingAudioClipInputValueChange.bind(this, input, soundMapEntry));
    },

    handlePlayingAudioClipInputValueChange(input, soundMapEntry) {
        const ext = '.' + input.files[0].name.split('.').pop().toLowerCase();

        this.readFile(input, (reader, file) => {
            cc.assetManager.loadRemote(reader.result, { ext }, (err, audioClip) => {
                this.audioManager.changeAudioClip(soundMapEntry, audioClip);
            });
        })
    },

    _handleEndSound(soundMapEntry) {
        const p = this._activeSoundControllers[soundMapEntry.id];

        if (p) {
            this.activeSoundsFolder.remove(p);
            this._activeSoundControllers[soundMapEntry.id] = null;
        }
    },

    handleAudioClipChange(data, soundMapEntry) {
        var input = document.createElement('input');
        input.setAttribute("type", "file");
        input.click();
        input.addEventListener('change', this.handleAudioClipInputValueChange.bind(this, input, data, soundMapEntry));
    },

    handlePlayAudioClip(data) {
        data = Object.assign({}, data);
        data.onAudioEndCallback = () => {
            this.current = null;
        };

        this.handleStopAudioClip(data);
        this.current = this.audioManager.play(data);
    },

    handleStopAudioClip(data) {
        if (this.current) {
            if (data.isMusic) {
                this.audioManager.stopMusic(data.musicTrack);
            } else {
                this.audioManager.stopSfx(this.current);
            }

            this.current = null;
        }
    },

    handleAudioClipInputValueChange(input, data, soundMapEntry) {
        const ext = '.' + input.files[0].name.split('.').pop().toLowerCase();

        this.readFile(input, (reader, file) => {
            cc.assetManager.loadRemote(reader.result, { ext }, (err, audioClip) => {
                data.clip = audioClip;
                data.clip.name = file.name;
                data.audioClipName = file.name;
                data.isAudioSprite = false;
                this.pane.refresh();

                // if (soundMapEntry) {
                //     debugger;
                // }
            });
        })
    },

    createAudioClip(input, data) {
        let out = new cc.AudioClip();
        // out._nativeUrl = this.IdGenerater;
        out._nativeAsset = data;
        out.duration = data.duration;

        return out;
    },

    readFile(input, onComplete) {
        let file = input.files[0];

        let reader = new FileReader();

        reader.readAsDataURL(file);

        reader.onload = () => {
            onComplete(reader, file);
        };

        reader.onerror = function () {
            console.log(reader.error);
        };
    },

    buildAudioPlayOptionPane() {
        const folder = this.pane.addFolder({
            title: 'Audio Events',
            expanded: false,
        });

        folder.addButton({ title: 'Export' }).
            on('click', this._downloadAudioEventJSON.bind(this));

        for (const prop in this.AudioPlayOptions) {
            const d = this.AudioPlayOptions[prop];
            const p = folder.addFolder({
                title: prop,
                expanded: false,
            })

            d.audioClipName = d.isAudioSprite ? 'audiosprite.mp3' : d.clip ? d.clip.name : '';

            // AudioPlayOption.key
            p.addInput(d, 'spriteName');
            p.addInput(d, 'isAudioSprite');
            p.addInput(d, 'volume', { min: 0, max: 1 });
            p.addInput(d, 'audioClipName');
            p.addInput(d, 'sideChain');

            // p.addInput(d, 'fadeIntime', { min: 0});
            // p.addInput(d, 'fadeInStartVolume', { min: 0, max: 1});
            // p.addInput(d, 'fadeInEndVolume', { min: 0, max: 1});
            // p.addInput(d, 'fadeOuttime', { min: 0});
            // p.addInput(d, 'fadeOutStartVolume', { min: 0, max: 1});
            // p.addInput(d, 'fadeOutEndVolume', { min: 0, max: 1});

            p.addButton({ title: 'Change Audio Clip' }).
                on('click', this.handleAudioClipChange.bind(this, d));
            p.addButton({ title: 'Play' }).
                on('click', this.handlePlayAudioClip.bind(this, d));
            p.addButton({ title: 'Stop' }).
                on('click', this.handleStopAudioClip.bind(this, d));

        }
    },

    buildAudioVolumeMixerPane() {
        const folder = this.pane.addFolder({
            title: 'Volume Mixer',
            expanded: false,
        });


        folder.addButton({ title: 'Export' }).
            on('click', this._downloadVolumeMixerJSON.bind(this));

        this.audioManager.node.on('load', () => {
            for (const audio in this.audioManager.loadedSoundSettings) {
                if (typeof audio === 'string') {

                    const s = this.audioManager.loadedSoundSettings[audio]

                    s.key = audio;

                    folder.addInput(s, 'volume', { label: audio, min: 0, max: 1 }).
                        on('change', this._updateAudioVolume.bind(this, s));
                }
            }
        })

    },

    _updateAudioVolume(audio) {
        if (audio.isSprite) {
            this.audioManager.setSoundVolume(audio.key.substr(7), audio.volume);
        } else {
            this.audioManager.setSoundVolume(audio.clip, audio.volume);
        }
    },

    _downloadAudioEventJSON() {
        const getFileName = () => {
            return `${require('PSConfig').get().gameName}-sound.json`;
        };


        const out = {};

        // // export only volume
        for (const audio in this.AudioPlayOptions) {
            if (audio) {
                out[audio] = {};
                out[audio].audioClipName = this.AudioPlayOptions[audio].audioClipName;
                out[audio].spriteName = this.AudioPlayOptions[audio].spriteName;
                out[audio].isAudioSprite = this.AudioPlayOptions[audio].isAudioSprite;
            }

        }
        // uses file-saver
        // eslint-disable-next-line no-undef
        saveAs(new Blob([JSON.stringify(out, null, '\t')]), getFileName());

    },

    _downloadVolumeMixerJSON() {
        const getFileName = () => {
            return `${require('PSConfig').get().gameName}-sound.json`;
        };

        const obj = {};

        // export only volume
        for (const audio in this.audioManager.loadedSoundSettings) {
            if (audio) {
                obj[audio] = {};
                obj[audio].volume = this.audioManager.loadedSoundSettings[audio].volume;
            }

        }


        // uses file-saver
        // eslint-disable-next-line no-undef
        saveAs(new Blob([JSON.stringify(obj, null, '\t')]), getFileName());

    },

    buildDynamicCompressorPane() {
        const folder = this.pane.addFolder({
            title: 'Side Chain',
            expanded: false,
        });

        const { compressorSettings } = this.audioManager;
        const updateSideChainSettings = () => {
            this.audioManager.updateSideChainSettings();
        }

        if (Howler.compressor) {
            folder.addMonitor(Howler.compressor, 'reduction', { title: 'reduction (Db)' });
            folder.addMonitor(Howler.compressor, 'reduction', { view: 'graph', min: -20, max: 0 });

            folder.addInput(compressorSettings, 'threshold', { min: -100, max: 0, title: 'threshold (Db)' }).on('change', updateSideChainSettings.bind(this));
            folder.addInput(compressorSettings, 'knee', { min: 0, max: 40 }).on('change', updateSideChainSettings.bind(this));
            folder.addInput(compressorSettings, 'ratio', { min: 1, max: 20 }).on('change', updateSideChainSettings.bind(this));
            folder.addInput(compressorSettings, 'attack', { min: 0, max: 1, title: 'attack (seconds)' }).on('change', updateSideChainSettings.bind(this));
            folder.addInput(compressorSettings, 'release', { min: 0, max: 1, title: 'release (seconds)' }).on('change', updateSideChainSettings.bind(this));
        } else {
            folder.addInput(compressorSettings, 'gain', { min: 0, max: 1, title: 'reduction' }).on('change', updateSideChainSettings.bind(this));
            folder.addInput(compressorSettings, 'attack', { min: 0, max: 5, title: 'attack (seconds)' }).on('change', updateSideChainSettings.bind(this));
            folder.addInput(compressorSettings, 'release', { min: 0, max: 5, title: 'release (seconds)' }).on('change', updateSideChainSettings.bind(this));
        }


        folder.addButton({ title: 'Connect Compressor' }).
         on('click', Howler.connectCompressor);
        folder.addButton({ title: 'Disconnect Compressor' }).
         on('click', Howler.disconnectCompressor);
    }

    // update() {
    //     this._updateMonitor();
    // }
});
